import { NotePlayer } from "./NotePlayer"
export class SoundState{
    setter:Function
    notePlayer:NotePlayer
    constructor(setter:Function){
      this.setter = setter
      this.notePlayer = new NotePlayer(1)
    }
     setState = (obj:any) => {
      this.setter((state:SoundState) => (obj))
    }
  }